export type InventoryPushContext =
  | { blocked: false; reason: null }
  | { blocked: true; reason: 'cross_organization' | 'mixed_organizations' };

/**
 * Shopify inventory credentials and push state are organization-scoped. A
 * client row visible through a shared 3PL location is readable inventory, not
 * permission to push that client's store from the provider context.
 */
export function resolveInventoryPushContext(input: {
  activeOrganizationId?: string | null;
  viewedOrganizationId?: string | null;
  hasMixedOrganizationRows?: boolean;
}): InventoryPushContext {
  const activeId = input.activeOrganizationId ?? null;
  const viewedId = input.viewedOrganizationId ?? null;

  if (viewedId && (!activeId || viewedId !== activeId)) {
    return { blocked: true, reason: 'cross_organization' };
  }
  if (!viewedId && input.hasMixedOrganizationRows) {
    return { blocked: true, reason: 'mixed_organizations' };
  }
  return { blocked: false, reason: null };
}
